import(/* webpackMode: "eager" */ "/vercel/path1/src/app/blog/page.tsx");
